module.exports = __webpack_public_path__ + "img/highmast_off.0cd5920f.svg";